import { rankingItems } from '@/mocks/home';

export default function SectionRanking() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return { icon: 'ri-arrow-up-line', cls: 'text-accent-600' };
    if (trend === 'down') return { icon: 'ri-arrow-down-line', cls: 'text-secondary-600' };
    return { icon: 'ri-subtract-line', cls: 'text-foreground-400' };
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-primary-600 mb-2">热度榜单</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热播排行榜</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">实时热度指数排行，看看大家都在追什么</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => {
            const ti = trendIcon(item.trend);
            return (
              <a
                key={item.id}
                href="#carousel"
                onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="flex items-center gap-3 md:gap-4 py-3.5 md:py-4 px-3 md:px-4 rounded-lg hover:bg-background-100 transition-colors duration-200 cursor-pointer group border-b border-background-200/40 last:border-b-0"
              >
                <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center font-heading text-sm font-bold ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-primary-400 text-background-50' :
                  item.rank === 3 ? 'bg-primary-300 text-primary-800' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 truncate">
                      {item.title}
                    </span>
                    {item.badge && (
                      <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded text-xs font-medium whitespace-nowrap">
                        {item.badge}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-500">{item.category}</span>
                </div>

                <div className="flex items-center gap-3 md:gap-4 text-right">
                  <div>
                    <div className="text-sm font-bold text-primary-600 font-heading">{item.hotIndex.toLocaleString()}</div>
                    <div className="text-xs text-foreground-400">热度指数</div>
                  </div>
                  <div className={`w-5 h-5 flex items-center justify-center ${ti.cls}`}>
                    <i className={ti.icon}></i>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}